export default {
  header: {
    homeLink: 'Home',
    aboutUsLink: 'About Us',
    servicesLink: 'Services',
    ourProjectsLink: 'Our projects',
    contact: 'Contact',
  },
  heroSection: {
    companyDescription: 'We create custom websites of any complexity',
    contactUs: 'Contact Us',
  },
  aboutUsSection: {
    aboutUsTitle: 'About Us',
    aboutUsDescription:
      "At Artemida Studio, we specialize in creating custom landing pages and corporate websites that help businesses establish a strong online presence. Our mission is to deliver modern, functional, and visually stunning solutions tailored to your brand's needs.\n\n" +
      'By combining creativity, the latest technologies, and a personalized approach, we build websites that are not only aesthetically appealing but also fast, user-friendly, and fully responsive.\n\n' +
      'Whether you need a high-converting landing page or a professional corporate website, Artemida Studio is here to bring your vision to life with high-quality, custom solutions.\n\n' +
      'Choose professionalism and creativity – let’s build your perfect website together!',
  },

  services: {
    servicesDescription:
      'We specialize in creating high-quality, custom digital solutions to elevate your business',
    title1: 'Landing Page',
    description1: [
      ` A well-designed landing page is a powerful tool for attracting
          customers, increasing conversions, and boosting your brand’s online
          presence. At Artemida Studio, we create high-quality, custom landing
          pages tailored to your business goals.`,
      `✔️ Modern & Unique Design – Visually stunning, brand-aligned pages
          that capture attention.`,
      `✔️ High Conversion Rate – Optimized layouts and compelling CTAs to
          drive engagement.`,
      ` ✔️ Fast & Responsive – Lightning-fast performance and seamless
          experience across all devices.`,
      `✔️ SEO & Marketing Ready – Built with best practices to improve
          visibility and attract organic traffic.`,
      ` ✔️ Fully Customizable – Every detail tailored to your specific needs
          and business identity.`,
    ],
  },
};
